export const PAGE_PATH = '/analytic';
